import React, { useState } from "react";
import { Button } from "@mui/material";
import "./UserFields.css";

const SetPasswordFields = ({
  onSetPassword,
  title = "",
  onClose,
  cancelLabel = "Cancel",
  submitLabel = "Set Password",
}) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");

  const validate = (value) => {
    if (!value) return "*Please enter a password.";
    if (value.length < 8) return "*Password must be at least 8 characters.";
    return "";
  };

  const handleChange = (value) => {
    setPassword(value);
    if (error) setError(validate(value));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const validationError = validate(password);
    if (validationError) {
      setError(validationError);
      return;
    }
    console.log("Setting new password:", password);
    onSetPassword(password);
    setPassword("");
    setError("");
  };

  const hasCancel = typeof onClose === "function";

  return (
    <div className="user-fields-container">
      {title ? (
        <div className="user-fields-header">
          <div className="user-fields-title">{title}</div>
        </div>
      ) : null}

      <form className="user-fields-form" onSubmit={handleSubmit}>
        <div className={`form-group ${error ? "error-input" : ""}`}>
          <input
            id="new_password"
            placeholder="Enter new password"
            className="input-field"
            type="password"
            value={password}
            onChange={(e) => handleChange(e.target.value)}
            required
          />
          {error && <span className="error-message">{error}</span>}
        </div>

        <div className={`user-fields-footer ${hasCancel ? "user-fields-footer--two" : "user-fields-footer--one"}`}>
          {hasCancel && (
            <Button
              variant="outlined"
              onClick={onClose}
              fullWidth
              className="user-fields-btn user-fields-btn--cancel"
            >
              {cancelLabel}
            </Button>
          )}

          <Button
            type="submit"
            variant="contained"
            disableElevation
            fullWidth
            className="user-fields-btn user-fields-btn--primary"
          >
            {submitLabel}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default SetPasswordFields;
